import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\User\GetUserByIdController::__invoke
* @see app/Http/Controllers/User/GetUserByIdController.php
* @route '/api/user/{user}'
*/
const GetUserByIdController = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetUserByIdController.url(args, options),
    method: 'get',
})

GetUserByIdController.definition = {
    methods: ["get","head"],
    url: '/api/user/{user}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\User\GetUserByIdController::__invoke
* @see app/Http/Controllers/User/GetUserByIdController.php
* @route '/api/user/{user}'
*/
GetUserByIdController.url = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { user: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { user: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            user: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        user: typeof args.user === 'object'
        ? args.user.id
        : args.user,
    }

    return GetUserByIdController.definition.url
            .replace('{user}', parsedArgs.user.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\User\GetUserByIdController::__invoke
* @see app/Http/Controllers/User/GetUserByIdController.php
* @route '/api/user/{user}'
*/
GetUserByIdController.get = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetUserByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\User\GetUserByIdController::__invoke
* @see app/Http/Controllers/User/GetUserByIdController.php
* @route '/api/user/{user}'
*/
GetUserByIdController.head = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetUserByIdController.url(args, options),
    method: 'head',
})

export default GetUserByIdController